import { useState } from 'react'
import styled from 'styled-components'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import AddTaskOutlinedIcon from '@mui/icons-material/AddTaskOutlined'
import TaskAltIcon from '@mui/icons-material/TaskAlt'
import DoNotDisturbOnOutlinedIcon from '@mui/icons-material/DoNotDisturbOnOutlined'
import EditOutlinedIcon from '@mui/icons-material/EditOutlined'
import { canRejectAiFind } from './remedialMeta'
import { BORDER, INK, MUTED } from './ui'

const RowMenu = ({ action, onOpen, onCreateTask, onComplete, onDismiss }) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const perms = action.permissions || {}

  const items = [
    action.stage === 'needs_decision' && perms.canConvert && { key: 'task', label: 'Create task', hint: 'Plan the work to put it right', Icon: AddTaskOutlinedIcon, run: onCreateTask },
    perms.canResolve && { key: 'complete', label: 'Mark as complete', hint: 'The problem has already been fixed', Icon: TaskAltIcon, run: onComplete },
    canRejectAiFind(action) && { key: 'dismiss', label: 'Not a real issue', hint: 'Remove this AI find, it is not a real problem', Icon: DoNotDisturbOnOutlinedIcon, run: onDismiss },
    { key: 'edit', label: 'Open and edit', hint: 'See every detail and make changes', Icon: EditOutlinedIcon, run: onOpen },
  ].filter(Boolean)

  const close = e => {
    if (e) e.stopPropagation()
    setAnchorEl(null)
  }

  return (
    <>
      <Trigger
        type='button'
        aria-label={`Actions for ${action.title}`}
        aria-haspopup='menu'
        aria-expanded={!!anchorEl}
        title='Actions'
        $open={!!anchorEl}
        onClick={e => { e.stopPropagation(); setAnchorEl(e.currentTarget) }}
        data-tour-id='remedials.row-menu'
      >
        <MoreVertIcon aria-hidden='true' />
      </Trigger>
      <Menu
        anchorEl={anchorEl}
        open={!!anchorEl}
        onClose={close}
        onClick={e => e.stopPropagation()}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        sx={{ zIndex: 1400 }}
        slotProps={{ paper: { sx: { minWidth: 240, mt: 0.5, borderRadius: '10px', boxShadow: '0 4px 16px rgba(12, 18, 41, 0.12)' } } }}
      >
        {items.map(item => (
          <MenuItem
            key={item.key}
            onClick={e => { close(e); item.run(action) }}
            sx={{ minHeight: 48, gap: 1.5, alignItems: 'center' }}
            data-tour-id={item.key === 'task' ? 'remedials.row-create-task' : item.key === 'dismiss' ? 'remedials.row-dismiss' : undefined}
          >
            <item.Icon aria-hidden='true' style={{ fontSize: 20, color: MUTED }} />
            <ItemText>
              <ItemLabel>{item.label}</ItemLabel>
              <ItemHint>{item.hint}</ItemHint>
            </ItemText>
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}

export default RowMenu

const Trigger = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border: 1px solid ${({ $open }) => ($open ? INK : 'transparent')};
  border-radius: 8px;
  background: ${({ $open }) => ($open ? '#fff' : 'transparent')};
  color: ${INK};
  cursor: pointer;
  svg { font-size: 22px; }
  &:hover { background: #fff; border-color: ${BORDER}; }
  &:focus-visible { outline: 2px solid ${INK}; outline-offset: 2px; }
`

const ItemText = styled.span`
  display: flex;
  flex-direction: column;
`

const ItemLabel = styled.span`
  font-size: 15px;
  font-weight: 600;
  color: ${INK};
`

const ItemHint = styled.span`
  font-size: 13px;
  color: ${MUTED};
`
